import { split, isNil, toNumber, join, isEmpty, isNumber } from 'lodash'
// import moment from 'moment';

const ValueFormatterHandler = {
  /**
     * 转成Number
     * @param {*} val
     * @returns {Number}
     */
  numbered(val) {
    return isNil(val) ? 0 : toNumber(val)
  },
  /**
     * 数字格式化尾部
     *
     * @param {*} val
     * @param {*} toInt
     * @returns {String}
     */
  numberFormatTail(val, toInt = false, toFixed = 2) {
    const numberVal = this.numbered(val)
    if (toInt) {
      return `${Math.floor(numberVal)}`
    } else {
      return parseFloat(numberVal).toFixed(toFixed)
    }
  },
  /**
     * 格式化数字
     * https://www.wolai.com/lijinzhe-work/xbCnpGrZzw5Ymat3MpEfJ
     * @param value
     * @param format
     * @returns {number|*}
     */
  format(val, format) {
    if (!format) {
      return val
    }
    const {
      toFixed = 2,
      magnitude,
      thousandsSeparatorFlag,
      emptyValue,
      autoSuffix = true
    } = format
    let { prefix = '', suffix = '' } = format
    prefix = prefix || ''
    suffix = suffix || ''
    if (emptyValue && isEmpty(val) && !isNumber(val)) {
      return emptyValue
    }
    if (!isNumber(val)) {
      return val
    }
    let numberVal = this.numbered(val)
    let autoSuffixStr = ''
    switch (magnitude) {
      case 'auto': {
        if (numberVal >= 10000 || numberVal <= -10000) {
          numberVal = numberVal / 10000
          autoSuffixStr = '万'
        }
        break
      }
      case 'thousand': {
        numberVal = numberVal / 1000
        autoSuffixStr = '千'
        break
      }
      case 'tenThousand': {
        numberVal = numberVal / 10000
        autoSuffixStr = '万'
        break
      }
      case 'million': {
        numberVal = numberVal / 1000000
        autoSuffixStr = '百万'
        break
      }
      case 'tenMillion': {
        numberVal = numberVal / 10000000
        autoSuffixStr = '千万'
        break
      }
      case 'hundredMillion': {
        numberVal = numberVal / 100000000
        autoSuffixStr = '亿'
        break
      }
      case 'percentage': {
        numberVal = numberVal * 100
        autoSuffixStr = '%'
        break
      }
    }
    suffix = (autoSuffix ? autoSuffixStr : '') + suffix
    let res = numberVal
    if (thousandsSeparatorFlag) {
      res = this.numberFormat(numberVal, true, ',', false, toFixed)
    } else {
      res = this.numberFormatTail(numberVal, false, toFixed)
    }
    return prefix + res + suffix
  },
  /**
     * 格式化数字
     *
     * @param {*} val
     * @param {*} needFixed
     * @param {*} seprator
     * @returns {String}
     */
  numberFormat(
    val,
    needFixed = false,
    seprator = ',',
    autoScale = false,
    toFixed = 2
  ) {
    let numberVal = this.numbered(val)
    if (needFixed) {
      numberVal = numberVal.toFixed(toFixed)
    }
    if (autoScale) {
      if (numberVal === '-0.00') {
        numberVal = '0.00'
      }
    }
    const ret = split(numberVal, '.')
    if (ret.length > 2) {
      throw new Error('添加千分符号')
    }
    ret[0] = ret[0].replace(
      /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
      '$&' + seprator
    )
    return join(ret, '.')
  },
  /**
     * 转成百分数
     *
     * @param {*} val
     * @returns {String}
     */
  numberPercent(val) {
    const numberVal = this.numbered(val)
    return this.numberFormat(numberVal / 100, true)
  },
  // /**
  //  * 构建Moment对象
  //  *
  //  * @param {*} dataVal
  //  * @returns {import('moment').Moment}
  //  */
  // buildMoment(dataVal) {
  //   return moment(dataVal);
  // },
  numberFormatThousand(val, toFixed = 0) {
    const numberVal = this.numbered(val)
    const format = {
      thousandsSeparatorFlag: true,
      toFixed: toFixed,
      magnitude: 'default',
      emptyValue: '-',
      autoSuffix: false
    }
    return this.format(numberVal, format)
  },
  numberFormatPercentage(val) {
    const numberVal = this.numbered(val)
    const format = {
      prefix: null,
      suffix: null,
      toFixed: 2,
      magnitude: 'percentage',
      thousandsSeparatorFlag: true,
      autoSuffix: true
    }
    return this.format(numberVal, format)
  }
}
export default ValueFormatterHandler
